module.exports = __webpack_public_path__ + "img/967323a536688d01da885bdf5a58daa0.455325c3.svg";